import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ProjectDialog = ({ project, onClose }) => (
  <Dialog open={!!project} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-4xl p-0 rounded-none border-stone-200 bg-[#FBFBF9] overflow-hidden max-h-[90vh] overflow-y-auto" data-testid="project-dialog">
      {project && (
        <div className="grid md:grid-cols-5">
          <div className="md:col-span-3 aspect-[4/3] md:aspect-auto bg-stone-200">
            <img src={project.image} alt={project.title} className="w-full h-full object-cover" />
          </div>
          <div className="md:col-span-2 p-8 flex flex-col">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#B85C38]">{project.category}</p>
            <DialogTitle className="font-serif font-light text-3xl text-stone-900 mt-3" data-testid="project-dialog-title">{project.title}</DialogTitle>
            <DialogDescription className="mt-5 text-stone-600 font-light leading-relaxed">{project.description}</DialogDescription>
            <dl className="mt-8 border-t border-stone-200 divide-y divide-stone-200 font-mono text-xs">
              {[["Client", project.client], ["Location", project.location], ["Type", project.category]].filter(([, v]) => v).map(([k, v]) => (
                <div key={k} className="flex justify-between py-3"><dt className="text-stone-500 uppercase tracking-wider">{k}</dt><dd className="text-stone-800">{v}</dd></div>
              ))}
            </dl>
            <a href="/contact" onClick={onClose} className="btn-dark mt-8 self-start" data-testid="project-dialog-enquire-btn">Discuss a similar project</a>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
